import { Component, OnInit } from '@angular/core';
import { AlternateNumbers } from '../../../../models/api/view/claim/details/custom-fields/alternate-numbers';
import { BaseComponent } from '../../../base/base.component';
import { SsnLabelComponent } from '../../../core/labels/ssn-label.component';
import { LoadingPanelComponent } from '../../../core/panels/loading-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { HandleLoadingState } from '../../../../decorators/handle-loading-state.decorator';

@Component({
  selector: 'app-alternate-numbers',
  imports: [
    TableComponent,
    ColumnComponent,
    SsnLabelComponent,
    LoadingPanelComponent,
  ],
  template: `
    <app-loading-panel [state]="loading ? 'Loading' : 'Loaded'" [error]="error"
      ><ng-template #loaded>
        <div class="tw-flex tw-gap-8 tw-py-8">
          <div class="tw-basis-2/3">
            <app-table
              [dataSource]="alternateNumbers"
              recordLabel="Alternate Number"
              [showPaginator]="false"
              [scrollable]="false"
              [sortField]="'alternateNumber'"
              [sortOrder]="1"
            >
              <app-column
                name="alternateNumber"
                label="Alternate Number"
                width="50%"
              >
                <ng-template #value let-data>
                  @if (data.isSsn) {
                    <app-ssn-label [value]="data.alternateNumber" />
                  } @else {
                    <span>{{ data.alternateNumber }}</span>
                  }
                </ng-template>
              </app-column>
              <app-column name="type" label="Type" width="50%" />
            </app-table>
          </div>
        </div> </ng-template
    ></app-loading-panel>
  `,
  styles: ``,
})
export class AlternateNumbersComponent extends BaseComponent implements OnInit {
  claim = this.view.currentClaim();
  alternateNumbers: AlternateNumbers[] = [];
  loading = false;
  error: any = null;

  @HandleLoadingState()
  async ngOnInit(): Promise<void> {
    this.alternateNumbers = await this.api.customFields.getAlternateNumbers(
      this.claim,
    );
  }
}
